/**
 * EdgeSettingsSetup
 *
 * Service that connects the Canvas Edges Settings in User Settings
 * to the EdgeRenderingService.
 *
 * Note: The sidebar registration has been removed - settings are now
 * in User Settings under "Canvas Edges".
 */

import { Service } from '@toeverything/infra';

import type { EdgeRenderingService } from '../rendering';
import { setCanvasEdgesRenderingService } from './canvas-edges-rendering-service';

/**
 * Sets up the connection between Canvas Edges Settings and EdgeRenderingService.
 *
 * Note: This service is kept for backward compatibility with the DI system.
 * The actual settings UI is now in User Settings (Canvas Edges panel).
 */
export class EdgeSidebarSetup extends Service {
  /**
   * Sets the EdgeRenderingService instance.
   * Called when the orchestrator initializes.
   */
  setEdgeRenderingService(service: EdgeRenderingService): void {
    setCanvasEdgesRenderingService(service);
  }

  /**
   * Clears the EdgeRenderingService reference.
   * Called when the orchestrator disposes.
   */
  clearEdgeRenderingService(): void {
    setCanvasEdgesRenderingService(null);
  }

  override dispose(): void {
    setCanvasEdgesRenderingService(null);
  }
}
